import React, { useEffect } from "react";
import { Paper, Box } from '@mui/material';
import { useState, Downgraded } from '@hookstate/core';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RoleDialog from "../../sharedcomponents/roleList/roleDialog";
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import Helper from '../../utility/helper';
import DataList from '../../sharedcomponents/dataList/dataList';
import { FULL_PERMISSION, VIEW_PERMISSION } from '../../constants/Constant';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));

const Roles = (props) =>
{
    const classes = useStyles();
    const setAll = useState(false);
    const roles = useState([]);
    const openDialog = useState(false);
    const openRoleDialog = useState(false);
    const eventRoleInfo = useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);

    const loading = useState(false);

    useEffect(() =>
    {
        const userInfo = Helper.getStorage('userInfo');
        if (Helper.isAdminUser(userInfo) || (userInfo.roles && Helper.isEventAdmin(userInfo)))
        {
            setModPermission(FULL_PERMISSION);
        }
        else
        {
            setModPermission(VIEW_PERMISSION);
        }
        getRoles()

    }, []);
    const redirectToCreate = () =>
    {
        openDialog.set(true);
    };
    const deleteRoles = () =>
    {
        const selected = roles.get().filter((roles) => roles.selected === true);
        if (selected.length === 0)
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select roles first',
            });
        } else
        {
            let message = selected.length == roles.get().length
                ? 'Do you want to delete all roles ?'
                : 'Do you want to delete selected roles ?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    // const selectAll = (event) =>
    // {
    //     setAll.set(event.target.checked);
    //     let newRoles = roles.attach(Downgraded).get();
    //     newRoles.map((item) => {
    //         if (item.eventID != 0)
    //             item['selected'] = event.target.checked;
    //     });

    //     roles.set(newRoles);
    // };
    // const onCheckSelect = (event, index) =>
    // {
    //     let newUsers = roles.attach(Downgraded).get();
    //     newUsers[index]['selected'] = event.target.checked;
    //     const checkAll = newUsers.every((obj) => obj.selected === true);
    //     setAll.set(checkAll);
    //     roles.set(newUsers);
    // };
    const editRole = (userInfo) =>
    {
        eventRoleInfo.set(userInfo.actualData);
        openRoleDialog.set(true);
    };
    const closeEditRole = () =>
    {
        eventRoleInfo.set(null);
        openRoleDialog.set(false);
    };
    const handleClose = () =>
    {
        openDialog.set(false);
    };
    const handleConfirmation = () =>
    {
        let deleteRoles = [];
        roles.get().map((role) =>
        {
            if (role.selected === true)
            {
                deleteRoles.push(role.actualData.roleID)
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_ROLES, {
            Ids: deleteRoles.join(','),
        })
            .then((res) =>
            {
                if (res.data)
                {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Roles deleted successfully',
                    });
                    getRoles();
                    setShowSearchRec(false);
                    setTimeout(() =>
                    {
                        setAll.set(false);
                    }, 300);
                }
            })
            .catch((error) =>
            {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while deleting roles';
                }
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const getRoles = () =>
    {
        const eventInfo = Helper.getStorage('eventInfo');
        loading.set(true);
        ApiHelper.get(APIURLConstants.GET_ROLES(eventInfo.eventID))
            .then((res) =>
            {
                if (res.data)
                {
                    loading.set(false);
                    let rolesData = [];
                    if (res.data.length > 0)
                    {
                        res.data.map((item) =>
                        {
                            rolesData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'roleID',
                                        roleID: item.roleID,
                                        width: '0.1',
                                    },
                                    {
                                        label: 'Name',
                                        key: 'roleName',
                                        roleName: item.roleName,
                                        width: '0.6',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'status',
                                        status: item.status
                                            ? 'Active'
                                            : 'Inactive',
                                        width: '0.2',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'edit',
                                        edit: 'Edit',
                                        width: '0.1',
                                        inColumn: true,
                                    },
                                ],
                                selected: false,
                                disableRow: (item.roleName == 'Event Admin' || item.roleName == 'Event Staff' || item.roleName == 'Participant' || item.roleName == 'Agent' ? true : false),
                            });
                        });
                    }
                    roles.set(rolesData);
                }
            })
            .catch((err) =>
            {
                loading.set(false);
                if (err.response && err.response.status === 401)
                {
                    console.log(err);
                }
            });

    }
    return (
        <>
            {loading.get() ? (
                <Box sx={loading.get() ? { paddingTop: '20%', paddingBottom: '20%' } : ''} className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) :
                <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none' }}>
                    {roles.get() ? (
                        <DataList
                            data={roles.attach(Downgraded).get()}
                            // onCheckSelect={onCheckSelect}
                            editRow={editRole}
                            handleClick={redirectToCreate}
                            title={''}
                            buttonTitle={'Add'}
                            deleteRows={deleteRoles}
                            showSearch={true}
                            searchLabel={'Search'}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            modPermission={modPermission}
                            label={'Roles'}
                        />
                    ) : null}
                    {openDialog.get() && (
                        <RoleDialog
                            open={openDialog.get()}
                            title="Add Roles"
                            handleClose={handleClose}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            addButton={true}
                            getRoles={getRoles}
                            allRoles={roles.attach(Downgraded).get()}
                        />
                    )}

                    {
                        <ConfirmationDialog
                            open={deleteConfirmation.get().open}
                            message={deleteConfirmation.get().message}
                            OkButtonText={deleteConfirmation.get().OkButtonText}
                            handleCnfClick={() =>
                                handleConfirmation(deleteConfirmation)
                            }
                            onCancelClick={() =>
                            {
                                deleteConfirmation.set({
                                    ...deleteConfirmation.get(),
                                    open: false,
                                });
                            }}></ConfirmationDialog>
                    }
                    {openRoleDialog.get() && (
                        <RoleDialog
                            open={openRoleDialog.get()}
                            title="Edit Roles"
                            handleClose={closeEditRole}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            addButton={false}
                            eventRoleInfo={eventRoleInfo.attach(Downgraded).get()}
                            getRoles={getRoles}
                            allRoles={roles.attach(Downgraded).get()}
                        />
                    )}
                    {snackBarProps.openSnack && (
                        <CustomizedSnackbars
                            {...snackBarProps}
                            onClose={() =>
                                setSnackBarProps({ ...snackBarProps, openSnack: false })
                            }></CustomizedSnackbars>
                    )}
                </Paper>
            }
        </>
    );
};

export default Roles;
